import React from "react";
import { useTheme } from "~app/providers/ThemeProvider";

const FolderSvg = () => {
  const { theme } = useTheme()!;

  let fill = "";
  switch (theme) {
    case "dark":
      fill = "#313131";
      break;
    case "light":
      fill = "#EFEFEF";
      break;
    case "glossy":
      fill = "#FFF";
      break;
    default:
      fill = "#FCFCD1";
      break;
  }

  return (
    <div className="clip-folder">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="100%"
        viewBox="5 -1 1167 892"
        fill="none"
      >
        <g filter="url(#filter0_d_3168_5218)">
          <path
            d="M4.52734 53.4717C4.52734 47.9488 9.00452 43.4716 14.5274 43.4717L33.3375 43.4717C37.2238 43.4717 40.758 41.2202 42.4005 37.6982L54.9541 10.7789C56.5966 7.25681 60.1308 5.00531 64.0171 5.00531L262.15 5.00534C266.073 5.00534 269.634 7.29916 271.256 10.8712L283.394 37.6059C285.016 41.178 288.576 43.4718 292.499 43.4718L1162.53 43.4716C1168.05 43.4716 1172.53 47.9488 1172.53 53.4716V878.797C1172.53 884.32 1168.05 888.797 1162.53 888.797H14.5274C9.00453 888.797 4.52734 884.32 4.52734 878.797V53.4717Z"
            fill={fill}
          />
        </g>
        <defs>
          <filter
            id="filter0_d_3168_5218"
            x="0.527344"
            y="0.00531006"
            width="1176"
            height="891.792"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy="-1" />
            <feGaussianBlur stdDeviation="2" />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_3168_5218"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_3168_5218"
              result="shape"
            />
          </filter>
        </defs>
      </svg>
    </div>
  );
};

export default FolderSvg;
